import { render, staticRenderFns } from "./approvalReportTemplate.vue?vue&type=template&id=68a53742&"
import script from "./approvalReportTemplate.vue?vue&type=script&lang=js&"
export * from "./approvalReportTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports